module.exports = __webpack_public_path__ + "static/media/Q2-8.03e87565.jpg";